import { useLoader, useThree } from "@react-three/fiber";
import { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { useMusic } from "../../common/hooks";

export default function Music({ url }) {
  const music = useRef();
  const { camera } = useThree();
  const [listener] = useState(() => new THREE.AudioListener());
  const buffer = useLoader(THREE.AudioLoader, url);
  const { isPlaying, volume } = useMusic();

  useEffect(() => {
    music.current.setBuffer(buffer);
    music.current.setRefDistance(1);
    music.current.setLoop(true);
    isPlaying ? music.current.play() : music.current.pause();
    camera.add(listener);
    return () => camera.remove(listener);
  }, [isPlaying]);

  useEffect(() => {
    music.current.setVolume(volume);
  }, [volume]);

  return (
    <positionalAudio ref={music} args={[listener]} position={[-2, 1, 2]} />
  );
}
